import React from 'react';
import { ButtonOptionPicker, SimpleList } from '../../toolympus/components/primitives';
import { useHistory } from 'react-router-dom';
import { useFields } from '../../toolympus/components/schemed';
import { Typography } from '@mui/material';
import { SimplePowerDocViewer } from '../../toolympus/components/PowerDoc/SimplePowerDocViewer';
import { PluggableDocumentationButton } from '../../toolympus/components/Documentation';
import { CopDecision, useCopDecisionList } from './useCopDecisionsList';
import { CreateCopDecisionDialog } from './CreateCopDecisionDialog';
import { PageTitleMenu } from '../../toolympus/components/primitives/PageTitleMenu';
import { CopTreeMenu } from './Tree/Common';


export const CopDecisionsList = () => {
  const data = useCopDecisionList();
  const history = useHistory();


  const fields = useFields({
    defaultFields: [
      "title",
      "decision",
      "decision_date",
      "created_at",
    ],
    blacklist: ["content", "search_highlights"],
    schema: data.schema,
    storageKey: "_biodev_copdecisionlist_fields",
    extraSettings: {
      description: { tableControl: SimplePowerDocViewer },
      createdAt: { utcToLocal: true },
    }
  });

  return (<>
    <SimpleList
      data={{
        ...data,
        filter: data.filter.filter,
        setFilter: data.filter.setFilter,
        create: () => { data.newRecord.startEditing(); return Promise.resolve({ _id: -1 } as CopDecision); }
      }}
      fields={[
      ]}
      tabs={[
        ["Drafts", "unpublished"],
        ["Published", "public"],
        ["All", "all"],
      ]}
      schema={data.schema}
      getLinkValue={cr => `/cop-decision/${cr._id}`}
      linkFields={[ "_id", "title" ]}
      title={
        <PageTitleMenu current="decisions" items={CopTreeMenu} title="COP Decisions" />
      }
      searchAuto
      searchAutoFocus
      fieldSetings={fields}
      sorting={data.sorting}
      tableProps={{
        tailAnchor: data.limitTrigger.pagingAnchor,
      }}
      headerActions={<>
        <Typography variant="caption" color="textSecondary" style={{ alignSelf: "flex-end" }}>Decisions: {data.count.data.total_records}</Typography>
      </>}
      headerViewActions={<>
        <ButtonOptionPicker
          options={[
            ["my", "me"],
            ["all", "all"],
          ]}
          selected={data.assignedFilter.value}
          setSelected={data.assignedFilter.update}
          />
      </>}
      headerTailActions={<>
        <PluggableDocumentationButton documentationKey="cop-decisions" />
      </>}
      />

    <CreateCopDecisionDialog
      {...data.newRecord}
      save={() => data.newRecord.save().then(cr => { history.push(`/cop-decision/${cr._id}`); return cr; })}
      schema={data.schema}
      />
  </>);
}
